module.exports = __webpack_public_path__ + "static/media/icon_orgao_publico.d74b01f8.svg";